import { z } from "zod";

const PathsSchema = z.object({
  auth: z.object({
    signIn: z.string().min(1),
    signUp: z.string().min(1),
    verifyMfa: z.string().min(1),
    callback: z.string().min(1),
    passwordReset: z.string().min(1),
    passwordUpdate: z.string().min(1),
  }),
  app: z.object({
    home: z.string().min(1),
    workspaces: z.string().min(1),
    personalTools: z.string().min(1),
    personalAccountSettings: z.string().min(1),
    personalAccountBilling: z.string().min(1),
    personalAccountBillingReturn: z.string().min(1),
    accountHome: z.string().min(1),
    accountContent: z.string().min(1),
    accountWorkflows: z.string().min(1),
    accountMediaLibrary: z.string().min(1),
    accountIntegrations: z.string().min(1),
    accountPersonalize: z.string().min(1),
    accountSettings: z.string().min(1),
    accountBilling: z.string().min(1),
    accountMembers: z.string().min(1),
    accountBillingReturn: z.string().min(1),
    joinTeam: z.string().min(1),
  }),
});

const pathsConfig = PathsSchema.parse({
  auth: {
    signIn: "/auth/sign-in",
    signUp: "/auth/sign-up",
    verifyMfa: "/auth/verify",
    callback: "/auth/callback",
    passwordReset: "/auth/password-reset",
    passwordUpdate: "/update-password",
  },
  app: {
    home: "/home",
    workspaces: "/home/workspaces",
    personalTools: "/home/tools",
    personalAccountSettings: "/home/settings",
    personalAccountBilling: "/home/billing",
    personalAccountBillingReturn: "/home/billing/return",
    accountHome: "/home/[account]",
    accountContent: "/home/[account]/content",
    accountWorkflows: "/home/[account]/workflows",
    accountMediaLibrary: "/home/[account]/library",
    accountIntegrations: "/home/[account]/integrations",
    accountPersonalize: "/home/[account]/personalize",
    accountSettings: `/home/[account]/settings`,
    accountBilling: `/home/[account]/billing`,
    accountMembers: `/home/[account]/members`,
    accountBillingReturn: `/home/[account]/billing/return`,
    joinTeam: "/join",
  },
} satisfies z.infer<typeof PathsSchema>);

export default pathsConfig;
